import {FiAlertCircle} from "react-icons/fi";

import {Alert} from "@/components/alert/Alert.tsx";
import {Button} from "@/components/button/Button.tsx";
import {AnalyzerRetryAlertProps} from "@/pages/analyzer/Analyzer.types.ts";
import {useAnalyzerContext} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";

export const AnalyzerRetryAlert = ({
  callout,
  variant = "maintenance",
  icon = FiAlertCircle,
  retryable = true,
  className,
  children,
}: AnalyzerRetryAlertProps) => {
  const {handleRetry} = useAnalyzerContext();

  return (
    <Alert variant={variant} icon={icon} callout={callout} className={className}>
      {children}
      {retryable && (
        <Button variant="secondary" size="extraSmall" onClick={handleRetry} className="mt-3">
          Retry
        </Button>
      )}
    </Alert>
  );
};
